import { SET_CHANGE_MESSAGE_TOKEN } from "../types.js";

export default () => async (dispatch) => {
    dispatch({type: SET_CHANGE_MESSAGE_TOKEN});
}